import React from "react";
import { Route, Switch } from "react-router-dom";
import Home from "./HomePage/home";
import Login from "./LoginPage/Login";
import Item from "./ItemPage/Item";
import Employee from "./EmployeePage/Employee";
import Contractor from "./ContractorPage/Contractor";
import Project from "./ProjectPage/Project";

import NotFound from "./NotFound/NotFound";

//Reports 
// import Summary from './Reports/SummaryPage/Summary';
import ProjectReport from './Reports/ProjectReportPage/ProjectReport';

// Components
import AppliedRoute from "./components/AppliedRoute";

//Tools
import ManageJobActions from "./Tools/ManageJobActions";

// Inventory
import JobStatusTransaction from "./JobStatusTransactionPage/JobStatusTransaction";
import StoreTransaction from "./StoreTransactionPage/StoreTransaction";
// import InventoryTransactions from "./Inventory/InventoryTransactions";
// import InventoryStockSummary from "./Inventory/InventoryStockSummary";

export default ({ childProps }) =>
  <Switch>
    <AppliedRoute path={`/login`} exact component={Login} props={childProps} />

    <AppliedRoute path={`/`} exact component={Home} props={childProps} />
    {/* <AppliedRoute path={`/transaction/jobstatus`} exact component={Import} props={childProps} /> */}
    {/* <AppliedRoute path={`/transaction/store`} exact component={Export} props={childProps} /> */}
    <AppliedRoute path={`/projects`} exact component={Project} props={childProps} />
    <AppliedRoute path={`/items`} exact component={Item} props={childProps} />
    <AppliedRoute path={`/contractors`} exact component={Contractor} props={childProps} />
    <AppliedRoute path={`/employees`} exact component={Employee} props={childProps} />

    {/* Reports */}
    <AppliedRoute path={`/report/project`} exact component={ProjectReport} props={childProps} />
    {/* <AppliedRoute path={`/report/summary`} exact component={Summary} props={childProps} />  */}
    <AppliedRoute path={`/transaction/jobstatus`} exact component={JobStatusTransaction} props={childProps} />
    <AppliedRoute path={`/transaction/store`} exact component={StoreTransaction} props={childProps} />
    {/* Tools */}
    <AppliedRoute path={`/tools/jobactions`} exact component={ManageJobActions} props={childProps} />
    <AppliedRoute path={`/tools/settings`} exact component={ManageJobActions} props={childProps} />

    {/* Not found */}
    <Route component={NotFound} />
  </Switch>;